class ReportsSummary {
	constructor(element) {
		this.element = element;
		this.summary = this.getSummary();
		this.defaultYear = element.dataset.defaultYear || '';

		this.totalElement = element.querySelector('[data-reports-total]');
		this.changeElement = element.querySelector('[data-reports-change]');
		this.topElement = element.querySelector('[data-reports-top]');
		this.regionsElement = element.querySelector('[data-reports-regions]');
		this.yearButtons = element.querySelectorAll('[data-year]');

		this.bindEvents();
		this.render(this.defaultYear);
	}

	getSummary() {
		try {
			return JSON.parse(this.element.dataset.summary || '{}');
		} catch (error) {
			return {};
		}
	}

	bindEvents() {
		this.yearButtons.forEach((button) => {
			button.addEventListener('click', () => {
				const year = button.dataset.year;

				this.render(year);
			});
		});
	}

	render(year) {
		const yearData = this.summary[year];

		if (!yearData) {
			return;
		}

		this.setActiveYear(year);
		this.renderTotal(yearData);
		this.renderYearToYear(year, yearData);
		this.renderTopRegions(yearData);
		this.renderRegions(yearData);
	}

	setActiveYear(year) {
		this.yearButtons.forEach((button) => {
			button.classList.toggle('is-active', button.dataset.year === year);
		});
	}

	renderTotal(yearData) {
		if (!this.totalElement) {
			return;
		}

		this.totalElement.textContent = yearData.totalReports || 0;
	}

	renderYearToYear(year, yearData) {
		if (!this.changeElement) {
			return;
		}

		const comparison = this.getYearToYearComparison(year, yearData);

		this.changeElement.className = 'reports-summary__change';

		if (!comparison.previousYear) {
			this.changeElement.classList.add('reports-summary__change--none');
			this.changeElement.innerHTML = `
				<span class="reports-summary__change-text">
					Brak danych porównawczych rok do roku.
				</span>
			`;

			return;
		}

		this.changeElement.classList.add(`reports-summary__change--${comparison.direction}`);

		const label = this.getComparisonLabel(comparison.direction);

		this.changeElement.innerHTML = `
			<span class="reports-summary__change-icon" aria-hidden="true">
				${this.getComparisonIcon(comparison.direction)}
			</span>

			<span class="reports-summary__change-value">
				${Math.abs(comparison.difference)}
			</span>

			<span class="reports-summary__change-text">
				${label} ${comparison.previousYear} roku
			</span>

			<span class="reports-summary__change-percent">
				${Math.abs(comparison.percentage)}%
			</span>
		`;
	}

	getYearToYearComparison(year, yearData) {
		const currentYear = Number(year);
		const previousYear = String(currentYear - 1);
		const previousYearData = this.summary[previousYear];

		if (!previousYearData) {
			return {
				previousYear: null,
				difference: 0,
				percentage: 0,
				direction: 'none',
			};
		}

		const currentTotal = Number(yearData.totalReports || 0);
		const previousTotal = Number(previousYearData.totalReports || 0);
		const difference = currentTotal - previousTotal;

		let percentage = 0;

		if (previousTotal > 0) {
			percentage = Number(((difference / previousTotal) * 100).toFixed(2));
		}

		let direction = 'none';

		if (difference > 0) {
			direction = 'increase';
		} else if (difference < 0) {
			direction = 'decrease';
		}

		return {
			previousYear,
			difference,
			percentage,
			direction,
		};
	}

	getComparisonLabel(direction) {
		if (direction === 'increase') {
			return 'więcej niż w';
		}

		if (direction === 'decrease') {
			return 'mniej niż w';
		}

		return 'bez zmian względem';
	}

	getComparisonIcon(direction) {
		if (direction === 'increase') {
			return '↑';
		}

		if (direction === 'decrease') {
			return '↓';
		}

		return '–';
	}

	renderTopRegions(yearData) {
		if (!this.topElement) {
			return;
		}

		const regions = yearData.topRegions || [];

		this.topElement.innerHTML = regions
			.map((item, index) => {
				return `
					<div class="reports-summary__top-item">
						<span class="reports-summary__top-position">${index + 1}</span>
						<span class="reports-summary__top-region">${item.region}</span>
						<strong class="reports-summary__top-count">${item.count}</strong>
					</div>
				`;
			})
			.join('');
	}

	renderRegions(yearData) {
		if (!this.regionsElement) {
			return;
		}

		const regions = yearData.reportsByRegion || [];

		this.regionsElement.innerHTML = regions
			.map((item) => {
				return `
					<div class="reports-summary__region">
						<span class="reports-summary__region-name">${item.region}</span>
						<strong class="reports-summary__region-count">${item.count}</strong>
					</div>
				`;
			})
			.join('');
	}
}

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.reports-summary').forEach((element) => {
		new ReportsSummary(element);
	});
});